import { useState } from "react";
import { trpc } from "@/lib/trpc";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Link } from "@tanstack/react-router";
import { CommunicationForm } from "@/components/forms/CommunicationForm";

export function AdminCommunicationsPage() {
  const [selectedCommunityId, setSelectedCommunityId] = useState<string>("");

  const { data: communities, isLoading } =
    trpc.admin.getAllCommunities.useQuery();

  const selectedCommunity = communities?.find(
    (c) => c.id === selectedCommunityId,
  );

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="container mx-auto max-w-6xl px-4 py-6 md:px-6 md:py-10">
      <div className="mb-8">
        <h1 className="text-2xl font-bold md:text-3xl">Panel de Admin</h1>
        <p className="text-muted-foreground">Gestioná usuarios y barrios.</p>
      </div>

      <div className="mb-6 flex gap-2">
        <Link
          to="/admin/users"
          className="rounded-xl px-4 py-2 text-sm font-medium hover:bg-accent"
        >
          Usuarios
        </Link>
        <Link
          to="/admin/communities"
          className="rounded-xl px-4 py-2 text-sm font-medium hover:bg-accent"
        >
          Barrios
        </Link>
        <Link
          to="/admin/communications"
          className="rounded-xl px-4 py-2 text-sm font-medium bg-primary text-primary-foreground"
        >
          Comunicados
        </Link>
        <Link
          to="/admin/my-access"
          className="rounded-xl px-4 py-2 text-sm font-medium hover:bg-accent"
        >
          Mi acceso
        </Link>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Enviar comunicado</CardTitle>
          <CardDescription>
            Enviá un mensaje a todos los miembros de un barrio.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="community">Barrio</Label>
            <Select
              value={selectedCommunityId}
              onValueChange={setSelectedCommunityId}
            >
              <SelectTrigger id="community">
                <SelectValue placeholder="Seleccionar un barrio" />
              </SelectTrigger>
              <SelectContent>
                {communities?.map((community) => (
                  <SelectItem key={community.id} value={community.id}>
                    {community.name} ({community._count.members} miembros)
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          {selectedCommunityId && selectedCommunity && (
            <CommunicationForm
              communityId={selectedCommunityId}
              communityName={selectedCommunity.name}
              onSuccess={() => setSelectedCommunityId("")}
              onCancel={() => setSelectedCommunityId("")}
            />
          )}

          {!selectedCommunityId && (
            <p className="text-sm text-muted-foreground py-4 text-center">
              Seleccioná un barrio para enviar un comunicado.
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
